<div
    class="style-items"
    fxLayout="row wrap"
    fxLayoutGap="28px"
    fxLayoutGap.gt-xs="38px"
    [ngStyle]="{
        paddingLeft: padding + 'px',
        flexWrap: scrolling === 'vertical' ? 'wrap' : 'nowrap',
        overflowX: scrolling === 'horizontal' ? 'scroll' : 'hidden',
        overflowY: scrolling === 'vertical' ? 'scroll' : 'hidden'
    }"
>
    <app-search-style-item
        *ngFor="let style of styles"
        (processEvent)="process($event)"
        [style]="style"
        [radius]="radius"
        [margin]="scrolling === 'vertical' ? 20 : 0"
    >
    </app-search-style-item>
</div>
